// extracted by mini-css-extract-plugin
export default {"Return__Wrapper":"Return_Return__Wrapper__xOyqy","Logo":"Return_Logo__AxBoB"};